import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

/** The search field above a list; results update as you type. */
export function SearchBox({
  value,
  onChange,
  placeholder,
  busy,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  busy?: boolean;
}) {
  return (
    <div className="relative mb-4 max-w-md">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
      <Input
        type="search"
        aria-label={placeholder}
        className="pl-9"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {busy && <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-400">Searching…</span>}
    </div>
  );
}
